// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import * as coreui from '@coreui/coreui'
import * as Lexxy from "@37signals/lexxy"
import "simplebar"
import "./controllers"
import "./fontawesome"

window.coreui = coreui

// Attachments stay off app-wide until blob serving and upload auth are wired (spec 2026-09-24-messageboard-rich-text).
Lexxy.configure({ default: { attachments: false }, messageboard: { headings: [] } })
